<template>
  <div class="wt-color" :key="colorRenderKey">
    <label @click.prevent>
      <span v-text="field.label" />
      <slot name="tooltip"></slot>
      <div>
        <input
          v-spectrum="{
            defaultValue: colorValue,
            enableColorPicker: field.enableColorPicker,
            options: field.options,
            onChange: updateValue,
          }"
          type="text"
          :name="field.name"
          :value="colorValue"
        />
        <div class="-eye-dropper" @click="openEyeDropper">
          <i class="wticon wticon-eyedropper" />
        </div>
      </div>
    </label>
  </div>
</template>

<script>
import fieldsMixin from '../mixins/fields.vue';

export default {
  props: {
    field: {
      type: Object,
      required: true,
      validator(value) {
        return _.every(
          ['defaultValue', 'enableColorPicker', 'label', 'name'],
          (prop) => _.includes(_.keys(value), prop)
        );
      },
    },
  },

  mixins: [fieldsMixin],

  data() {
    return {
      colorValue: false,
      colorRenderKey: Date.now(),
    };
  },

  created() {
    this.colorValue = _.isDefined(this.field.value)
      ? this.field.value
      : this.field.defaultValue;
    this.emitChange({ newValue: this.colorValue, makeDirty: false });
    this.$watch('colorValue', (newValue) => {
      this.emitChange({ newValue });
    });
  },

  mounted() {
    this.fieldReadyNextTick();
  },

  methods: {
    updateValue(value) {
      this.$set(this, 'colorValue', value);
    },
    openEyeDropper() {
      if (!window.EyeDropper) {
        app.doctorController.report(
          'Browser does not support the EyeDropper API'
        );
        window.alert('Sorry, your browser does not support the EyeDropper API');
        return;
      }

      const eyeDropper = new window.EyeDropper();

      eyeDropper
        .open()
        .then((result) => {
          this.updateValue(tinycolor(result.sRGBHex).toHex8());
          this.colorRenderKey = Date.now();
        })
        .catch((e) => {});
    },
  },
};
</script>

<style lang="scss" scoped>
.-eye-dropper {
  width: 30px;
  float: right;
  display: flex;
  align-items: center;
  justify-content: center;
  border: solid 1px rgba(0, 0, 0, 0.2);
  background: #eee;
  color: #333;
  cursor: pointer;
  height: 100%;
  margin-right: 5px;

  &:hover {
    border-color: #f0c49b;
    color: #111;
  }
  .wticon {
    position: relative !important;
    font-size: 18px;
    transform: none !important;
    top: inherit !important;
    left: inherit !important;
    bottom: inherit !important;
    right: inherit !important;
  }
}
</style>
